var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subpage"},[_c('Header',{attrs:{"title":"风水罗盘","is-sub-page":true}}),_c('div',[_vm._v("111111")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }